window.FileUpload = {
	
	addIt: function(data){
		if (data[0].success){
			var newLine = '<li id="fid_'+data[0].file_infos.file_id+'">'
						+'<img src="/img/classeur/'+data[0].file_infos.extension+'.png" height="20" width="20"/>\n'
						+'	<a href="'+data[0].public_path+'" title="'+data[0].name+'">'
						+data[0].file_infos.file_fullname
						+'	</a>'
						+'	<a href="javascript:;" onclick="FileUpload.deleteIt('+data[0].file_infos.file_id+')" class="deleteLinkedDoc">'+Loc.g('supprimer')+'</a>'	
						+'</li>';
			$('.linkedDocs').append(newLine);
			$('#nodoc').remove();
			MyFacture.customForm();
		}
	},
	
	
	deleteIt: function(fid){
		var datas = {action:"deletefile", fid:fid};
		MyFacture.post("uploadFile", datas, function(data){FileUpload.deleteItCallback(data)}, "json");
	},
	
	deleteItCallback: function(data){
		if (data.filedelid) {
			$('#fid_'+data.filedelid).remove();
		} else {
			Push.error(Loc.g("Le fichier n'est pas accessible"));
		}
	},
	
};